export const FETCH_SALARY = 'FETCH_SALARY';
export const FETCH_SALARY_SUCCESS = 'FETCH_SALARY_SUCCESS';
export const FETCH_SALARY_ERROR = 'FETCH_SALARY_ERROR';

export const fetchSalary = () => ({ type: FETCH_SALARY });
export const fetchSalarySuccess = (payload: any) => ({ type: FETCH_SALARY_SUCCESS, payload });
export const fetchSalaryError = (payload: any) => ({ type: FETCH_SALARY_ERROR, payload });
